import { IntegrationInstallationId, ReleaseStepType, RunwayModelsResponse } from '@/types';
import { StepGraphOrder } from '@/types/workflow';

export enum WorkflowUpdatable {
    UpdateAutomationSettings = 'UpdateAutomationSettings',
    CreateStepConfig = 'CreateStepConfig',
    UpdateStepGraph = 'UpdateStepGraph',
}

export interface CreateRegressionTestingStepSettings {
    upstreamCIStepConfigId?: string;
}

export interface CreateCIStepSettings {
    ciStepConfigIdByDownstreamStepConfigId: Record<string, string>;
}

export interface CreateStepConfigRequest {
    archetype: ReleaseStepType;
    name: string;
    integrationInstallationIds: IntegrationInstallationId[];
    stepGroupIndex: number;
    archetypeGroupIndex: number;
    insertAsNewArchetypeGroup: boolean;
    destinationStepConfigIds?: string[];
    archetypeSpecificSettings?: CreateCIStepSettings | CreateRegressionTestingStepSettings;
}

export interface UpdateStepGraphRequest {
    stepGroups: StepGraphOrder;
}

export const UPDATE_WORKFLOW_OVERVIEW = 'UPDATE_WORKFLOW_OVERVIEW';
export const CLEAR_WORKFLOW_OVERVIEW = 'CLEAR_WORKFLOW_OVERVIEW';
export const UPDATE_WORKFLOW_STEP_GRAPHS = 'UPDATE_WORKFLOW_STEP_GRAPHS';

export interface UpdateWorkflowOverviewAction {
    type: typeof UPDATE_WORKFLOW_OVERVIEW;
    payload: RunwayModelsResponse['workflowOverview'];
}

export const updateWorkflowOverview = (
    payload: RunwayModelsResponse['workflowOverview'],
): UpdateWorkflowOverviewAction => {
    return {
        type: UPDATE_WORKFLOW_OVERVIEW,
        payload: payload,
    };
};

export interface ClearWorkflowOverviewAction {
    type: typeof CLEAR_WORKFLOW_OVERVIEW;
    payload: {
        appId: string;
    };
}

export const clearWorkflowOverview = (payload: { appId: string }): ClearWorkflowOverviewAction => {
    return {
        type: CLEAR_WORKFLOW_OVERVIEW,
        payload: payload,
    };
};

export interface UpdateWorkflowStepGraphAction {
    type: typeof UPDATE_WORKFLOW_STEP_GRAPHS;
    payload: RunwayModelsResponse['workflowStepGraphs'];
}

export const updateWorkflowStepGraphs = (
    payload: RunwayModelsResponse['workflowStepGraphs'],
): UpdateWorkflowStepGraphAction => {
    return {
        type: UPDATE_WORKFLOW_STEP_GRAPHS,
        payload: payload,
    };
};
